<script setup lang="ts">
export interface BaseSliderSkeletonProps {
  hasControls?: boolean;
}

const props = defineProps<BaseSliderSkeletonProps>();
</script>

<template>
  <div class="baseSlider skeletonLoading">
    <template v-if="props.hasControls">
      <div class="baseSlider__button baseSlider__buttonBack" tag="div" type="icon" name="baseSlider-slide-back">
        <IconChevronLeft class="relative z-10" />
      </div>
      <BaseButton class="baseSlider__button baseSlider__buttonNext" tag="div" type="icon" name="baseSlider-slide-back">
        <IconChevronRight class="relative z-10" />
      </BaseButton>
    </template>
  </div>
</template>

<style lang="scss">
.baseSlider {
  @apply relative w-full h-full overflow-hidden flex flex-1;

  .baseSlider__buttonBack {
    @apply left-6;
  }

  .baseSlider__buttonNext {
    @apply right-6;
  }

  .baseSlider__button {
    @apply w-10 h-10 sm:w-14 sm:h-14
    absolute z-30 top-1/2
    mx-auto rounded-full overflow-hidden
    flex items-center justify-center
    transition duration-100
    hover:shadow-lg;

    color: #fff;
    transform: translateY(-50%);

    &::before {
      @apply absolute w-full h-full z-0 opacity-75 rounded-full;

      content: '';
      background-color: #0f1624;
    }
  }
}
</style>
